import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';

import React from 'react';
import PropTypes from 'prop-types';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import styles from './styles.module.less';

const ActionMenu = ({ children }) => {
  return (
    <DropdownMenu dropdownMenuClassName={styles['action-menu-wrapper']}>
      <DropdownMenuToggler
        className={styles['actions-dropdown']}
        hideChevron
        openClassName={styles['icon-open']}
        testId='action-menu-toggler'
        theme='unstyled'
      >
        <div className={styles['icon-wrapper']}>
          <FontAwesomeIcon icon={faEllipsisH} />
        </div>
      </DropdownMenuToggler>
      {children}
    </DropdownMenu>
  );
};

ActionMenu.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ActionMenu;
